/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BootstrapTenantAdminRequest,
  TenantResponse,
} from '../models/index';
import {
    BootstrapTenantAdminRequestFromJSON,
    BootstrapTenantAdminRequestToJSON,
    TenantResponseFromJSON,
    TenantResponseToJSON,
} from '../models/index';

export interface BootstrapTenantAdminOperationRequest {
    tenantId: string;
    bootstrapTenantAdminRequest: BootstrapTenantAdminRequest;
    sessionId?: string;
}

/**
 * TenantAdminManagementApi - interface
 * 
 * @export
 * @interface TenantAdminManagementApiInterface
 */
export interface TenantAdminManagementApiInterface {
    /**
     * Ensures an admin exists and is assigned to the tenant, updates tenant.adminUserId, and returns updated tenant
     * @summary Bootstrap tenant admin user
     * @param {string} tenantId Tenant ID
     * @param {BootstrapTenantAdminRequest} bootstrapTenantAdminRequest 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantAdminManagementApiInterface
     */
    bootstrapTenantAdminRaw(requestParameters: BootstrapTenantAdminOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantResponse>>;

    /**
     * Ensures an admin exists and is assigned to the tenant, updates tenant.adminUserId, and returns updated tenant
     * Bootstrap tenant admin user
     */
    bootstrapTenantAdmin(requestParameters: BootstrapTenantAdminOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantResponse>;

}

/**
 * 
 */
export class TenantAdminManagementApi extends runtime.BaseAPI implements TenantAdminManagementApiInterface {

    /**
     * Ensures an admin exists and is assigned to the tenant, updates tenant.adminUserId, and returns updated tenant
     * Bootstrap tenant admin user
     */
    async bootstrapTenantAdminRaw(requestParameters: BootstrapTenantAdminOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantResponse>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling bootstrapTenantAdmin().'
            );
        }

        if (requestParameters['bootstrapTenantAdminRequest'] == null) {
            throw new runtime.RequiredError(
                'bootstrapTenantAdminRequest',
                'Required parameter "bootstrapTenantAdminRequest" was null or undefined when calling bootstrapTenantAdmin().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/tenants/{tenantId}/admins/bootstrap`;
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BootstrapTenantAdminRequestToJSON(requestParameters['bootstrapTenantAdminRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantResponseFromJSON(jsonValue));
    }

    /**
     * Ensures an admin exists and is assigned to the tenant, updates tenant.adminUserId, and returns updated tenant
     * Bootstrap tenant admin user
     */
    async bootstrapTenantAdmin(requestParameters: BootstrapTenantAdminOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantResponse> {
        const response = await this.bootstrapTenantAdminRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
